import React from 'react';
import { useSelector } from 'react-redux';
import { State } from 'model/State';
import { MACInvoicesPage } from './InvoicesPage';

// this component can be used to show a particular order
// and scrolled into view port using URL: `/purchase/my/billing/quotes/{orderId}?hash=:hash`
export const MACInvoicesPreselectedPage = () => {
  const orderId = useSelector((state) => (state as State).location.payload.orderId);

  return <MACInvoicesPage orderId={orderId} />;
};
